import React from "react";
import { svg } from "../../../../../Assets/svg";
import { Modal } from "antd";
import FullScreenLoader from "../../../../Components/FullScreenLoader";

const PrinterConnectionErrorModal = ({
  visible,
  setIsModalVisible,
  isPrinterError,
}: any) => {
  const onClose = () => {
    setIsModalVisible(false);
  };
  return (
    <Modal
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          {" "}
          <h2 style={{ color: "#d32f2f", marginTop: 0 }}>
            ⚠️ DYMO Printer Not Detected
          </h2>
        </div>
      }
      visible={visible}
      onCancel={onClose}
      width={"40rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
          >
            CLOSE
          </button>
        </div>
      }
      className="commonModalClass"
    >
      <div>
        <p>
          {isPrinterError
            ? "DYMO service connected successfully, but no printer was detected."
            : "We couldn't connect to the DYMO service on your computer. Please follow these steps:"}
        </p>

        <ol style={{ textAlign: "left", lineHeight: "1.6" }}>
          {isPrinterError ? (
            ""
          ) : (
            <li>
              <strong>Check Software:</strong> Ensure{" "}
              <strong>DYMO Connect</strong> is installed and running in your
              system tray (bottom right of your screen).
            </li>
          )}
          <li>
            <strong>Check Connection:</strong> Ensure your{" "}
            <strong>DYMO 5XL</strong> is plugged in via USB and has a solid
            light.
          </li>
          {isPrinterError ? (
            ""
          ) : (
            <li>
              <strong>HTTPS Permissions (Crucial):</strong>
              <br />
              Click this link:{" "}
              <a
                href="https://127.0.0.1:41951/DYMO/DLS/Printing/StatusConnected"
                target="_blank"
                rel="noreferrer"
              >
                Local Service Check
              </a>
              <br />
              If you see "Your connection is not private," click{" "}
              <strong>Advanced</strong> and then{" "}
              <strong>Proceed to 127.0.0.1 (unsafe)</strong>.
            </li>
          )}
        </ol>
      </div>
    </Modal>
  );
};

export default PrinterConnectionErrorModal;
